function Topbar({ judul, sub }) {
  const tanggal = new Date().toLocaleDateString('id-ID', {
    weekday: 'long', year: 'numeric',
    month: 'long', day: 'numeric'
  });

  return (
    <header className="topbar">
      <div className="topbar-left">
        <h1 className="page-title">{judul}</h1>
        <span className="page-sub">{sub}</span>
      </div>
      <div className="topbar-right">
        <div className="topbar-date">📅 {tanggal}</div>
      </div>
    </header>
  );
}

export default Topbar;